import { useEffect } from "react";

export default function useDevtoolsDetector(options = {}) {
  const { onOpen = null, onClose = null, showWarning = true } = options;

  useEffect(() => {
    // Only run in PRODUCTION
    if (process.env.NODE_ENV !== "production") {
      return;
    }

    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Block keyboard shortcuts
    const handleKey = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["I","J","C"].includes(e.key.toUpperCase())) ||
        (e.ctrlKey && e.key.toUpperCase() === "U") || 
        (e.metaKey && e.shiftKey && e.key.toUpperCase() === "I") // CMD + Shift + I (Mac)
      ) {
        e.preventDefault();
        e.stopPropagation();
        if (showWarning) alert("Developer tools are disabled on this page.");
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    window.addEventListener("keydown", handleKey, true);

    // DevTools detection
    let devtoolsOpen = false;
    const threshold = 160;

    const checkDevTools = () => {
      const widthDiff = window.outerWidth - window.innerWidth;
      const heightDiff = window.outerHeight - window.innerHeight;
      const isOpen = widthDiff > threshold || heightDiff > threshold;

      if (isOpen && !devtoolsOpen) {
        devtoolsOpen = true;
        if (onOpen) onOpen();
        if (showWarning) console.warn("DevTools detected!");
      } else if (!isOpen && devtoolsOpen) {
        devtoolsOpen = false;
        if (onClose) onClose();
      }
    };

    const interval = setInterval(checkDevTools, 800);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("keydown", handleKey, true);
      clearInterval(interval);
    };
  }, [onOpen, onClose, showWarning]);
}
